import script from "./AppDialogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDialogModal.vue?vue&type=script&setup=true&lang=js"

import "./AppDialogModal.vue?vue&type=style&index=0&id=41028e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41028e04"]])

export default __exports__